import {styled} from "@mui/material/styles";
import ToggleButtonGroup, {
	toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup';

export const CoverageItem = styled("div")(() => ({
	padding: 0,
	minWidth: 205,
	height: '100%',
	minHeight: '175px',
	borderRadius:'4px',
	backgroundColor: '#FFFFFF',
}))

export const TotalBlock = styled("div")(({theme}) => ({
	backgroundColor:  theme.palette.primary.main,
	padding: '24px 12px',
	color: theme.palette.background.default,
	borderRadius: '0 0 8px 8px',
}))

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => {
	return {
		position: 'relative',
		backgroundColor: 'rgba(255, 255, 255, 0.5)',
		borderRadius: '6px',
		padding: '4px',
		border: 'none',
		display: 'flex',
		boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
		'& .MuiToggleButtonGroup-grouped': {
			margin: 0,
			border: 'none',
			borderRadius: '4px',
			padding: '8px 16px',
			position: 'relative',
			zIndex: 1,
			transition: 'color 0.3s ease',
			color: theme.palette.primary.light,
			backgroundColor: 'transparent',
			flex: 1,
			minWidth: 0,
			[theme.breakpoints.down('sm')]: {
				padding: '10px 16px',
				fontSize: '14px',
			},
			'&:not(:first-of-type)': {
				borderRadius: '4px',
				marginLeft: '4px',
			},
			'&:first-of-type': {
				borderRadius: '4px',
			},
			'&.Mui-selected': {
				backgroundColor: 'transparent',
				fontWeight: 600,
				'& .MuiTypography-root': {
					color: theme.palette.text.primary,
					transition: 'color 0.3s ease',
				},
				'&:hover': {
					backgroundColor: 'transparent',
				},
			},
			'&:hover': {
				backgroundColor: 'transparent',
			},
			'& .MuiTypography-root': {
				fontSize: 'inherit',
				whiteSpace: 'nowrap',
				color: theme.palette.primary.contrastText,
				transition: 'color 0.3s ease',
				[theme.breakpoints.down('sm')]: {
					fontSize: '14px',
				},
			},
		},
	}
});
